import Color from "color";
import { OverlayVariant } from "@/constants/media";
import { useGetHEXColorByColorVariant } from "@/hooks/useGetHEXColorByColorVariant";
import type { BaseSiteBuilderModule } from "@/types/site-builder";

export interface BackgroundOverlayProps {
  settings: BaseSiteBuilderModule["style"]["background"]["overlay"];
}

export default function BackgroundOverlay(props: BackgroundOverlayProps) {
  const {
    settings: { variant, colorVariant, opacity, angle },
  } = props;
  const hexColor = useGetHEXColorByColorVariant(colorVariant);

  if (!hexColor) return null;

  const color = Color(hexColor)
    .alpha(opacity / 100)
    .toString();

  const getOverlayStyle = () => {
    switch (variant) {
      case OverlayVariant.Variant1:
        return { background: color };

      case OverlayVariant.Variant2:
        return {
          background: `linear-gradient(${angle}deg, ${color} 0%, rgba(0, 0, 0, 0) 100%)`,
        };

      default:
        return {};
    }
  };

  return <div className="inset-overlay" style={getOverlayStyle()} />;
}
